// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DeviceHierarchy } from "./device-hierarchy";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Physical control device within a channel.
 */
export class Device implements flatbuffers.IUnpackableObject<DeviceT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Device {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDevice(bb: flatbuffers.ByteBuffer, obj?: Device): Device {
    return (obj || new Device()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDevice(bb: flatbuffers.ByteBuffer, obj?: Device): Device {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Device()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  type(): DeviceHierarchy {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceHierarchy.PRIMARY;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startDevice(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, channelIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: DeviceHierarchy) {
    builder.addFieldInt8(3, type, DeviceHierarchy.PRIMARY);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, deletedAtOffset, 0);
  }

  static endDevice(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): DeviceT {
    return new DeviceT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.type(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: DeviceT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.type = this.type();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): DeviceT {
    const t = new DeviceT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class DeviceT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public channelId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public type: DeviceHierarchy = DeviceHierarchy.PRIMARY,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    Device.startDevice(builder);
    Device.addId(builder, id);
    Device.addChannelId(builder, channelId);
    Device.addOrganizationId(builder, organizationId);
    Device.addType(builder, this.type);
    Device.addCreatedAt(builder, createdAt);
    Device.addUpdatedAt(builder, updatedAt);
    Device.addDeletedAt(builder, deletedAt);

    return Device.endDevice(builder);
  }

  clone(): DeviceT {
    const obj = new DeviceT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.type = this.type;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: DeviceT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.type !== other.type) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyDevice(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
